<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>景区管理</el-breadcrumb-item> 
    </el-breadcrumb>
    <el-card style="margin-top:20px">
      <div class="titleStyle">
        <el-input placeholder="景区名称" v-model="data.scenic_name"></el-input>
        <el-input placeholder="联系人" v-model="data.user_name"></el-input>
        <el-select v-model="data.ProID" placeholder="请选择省份" clearable>
          <el-option
            v-for="item in cityProvince"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
          ></el-option>
        </el-select>
        <el-button @click="Chaxun">查询</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="name" label="景区LOGO">
            <template slot-scope="scope">
              <img :src="scope.row.WebSiteLOGO" style="width:36px;height:36px;vertical-align: middle;" alt />
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="简称"></el-table-column>
          <el-table-column prop="Name" label="全称"></el-table-column>
          <el-table-column prop="LinkMan" label="联系人"></el-table-column>
          <el-table-column prop="Phone" label="联系电话"></el-table-column>
          <el-table-column prop="E_Mail" label="Email"></el-table-column>
          <el-table-column prop="Address" label="地址"></el-table-column>
          <el-table-column prop="Status" label="景区状态">
            <template slot-scope="scope">
              <img src="@/images/distributor/dl.png" alt v-if="scope.row.Status=='1'"/>
              <img src="@/images/distributor/dh.png" alt v-if="scope.row.Status=='2'" />
              <span style="margin-left:5px">{{scope.row.Status=='1'?'上架':'下架'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Balance" label="余额"></el-table-column>
          <el-table-column prop="OverDraftMoney" label="透支金额">
            <template slot-scope="scope">
              <span>{{ scope.row.OverDraftMoney }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="AlreadyOverdraft" label="已透支金额"></el-table-column>
            <el-table-column prop="address" label="操作">
                  <template slot-scope="scope"> 
                    <!-- <el-button type="text" @click="seeShopFn(scope.row)">查看产品</el-button>  -->
                    <el-button type="text" @click="raRecharg(scope.row)">充值</el-button>
            </template>
          </el-table-column> 
        </el-table>

        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page.sync="data.page"  @current-change="currenchange"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
    </el-card>
    <el-dialog :close-on-click-modal="false"
      title="充值"
      :visible.sync="RechargeDialogVisible"
      :before-close="RechargeHandleClose"
      width="38.6%"
      center
      top="30vh"
    >
      <!-- <el-divider></el-divider>
      <div class="RechargeContent">
        
      </div> -->
      <el-divider></el-divider>
      <div class="RechargeContent">
        <el-form ref="formRe" :model="formRe" label-width="75px">
          <div class="RechargeItem">
            <el-form-item label="充值金额:">
              <el-input v-model="formRe.money" placeholder="请输入充值金额">
                <template slot="append">
                    元
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="支付方式:">
              <el-radio-group v-model="formRe.pay_way">
                <el-radio label="1">微信</el-radio>
                <el-radio label="2">支付宝</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="itemBtnS" >
              <el-button @click="chongzhi">充值</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div>
          <el-table
            :data="RecordArr"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column prop="PayTime" label="充值时间" width="180"></el-table-column>
            <el-table-column prop="Pay" label="充值金额"></el-table-column>
            <el-table-column  label="充值前金额">
               <template slot-scope="scope">
                 <span>{{ (scope.row.Balance-scope.row.Pay).toFixed(2) }}</span>
               </template>
            </el-table-column>
            <el-table-column prop="Balance" label="余额"></el-table-column>
            <el-table-column prop="UserName" label="操作人"></el-table-column>
            <el-table-column prop="remark" label="备注">
                <template>
                  自操作
                </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{totals}}条记录，</span>
          <span class="demonstration">当前显示第{{datas.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="datas.page_size" :total="totals" :current-page="datas.page"  @current-change="ListArr"></el-pagination>  
        </div>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 产品列表弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="产品列表"
      :visible.sync="shopListVisible"
      :before-close="shopListHandleClose"
      width="84.4%"
      center
      top="5vh"
    >
      <el-divider></el-divider>
      <div class="shopTitle">
        <el-input placeholder="请输入产品名称" v-model="data1.val"></el-input>
        <el-select v-model="data1.scenicid" placeholder="全部景区" clearable>
          <el-option
            v-for="item in tableData"
            :key="item.ScenicID"
            :label="item.Name"
            :value="item.ScenicID"
          ></el-option>
        </el-select>
        <el-select v-model="data1.UseFlag" placeholder="全部产品" clearable>
          <el-option
              v-for="item in use"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
        </el-select>
        <el-button @click="cxBtns">查询</el-button>
      </div>
      <div>
        <el-table
          :data="tableData1"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="ProductID" label="产品ID"></el-table-column>
          <el-table-column prop="ProductName" label="产品名称"></el-table-column>
          <el-table-column prop="Name" label="景区名称"></el-table-column>
          <el-table-column prop="ScenicID" label="景区ID"></el-table-column>
          <el-table-column prop="Price" label="门市价"></el-table-column>
          <el-table-column prop="SellPrice" label="建议价"></el-table-column>
          <el-table-column prop="AgentPrice" label="代理价"></el-table-column>
          <el-table-column prop="ValidBeginDate" label="销售有效期">
            <template slot-scope="scope">{{ scope.row.ValidBeginDate }} - {{ scope.row.ValidEndDate }}</template>
          </el-table-column>
          <el-table-column prop="DayNumber" label="每日购买限制"></el-table-column>
          <el-table-column prop="AllNumber" label="总购买限制">
          </el-table-column>
          <el-table-column prop="address" label="状态">
          <template slot-scope="scope">
            <img src="@/images/distributor/dh.png" alt v-if="scope.row.UseFlag=='1'"/>
            <img src="@/images/distributor/dl.png" alt  v-if="scope.row.UseFlag=='0'"/>
            <span style="margin-left:5px">{{scope.row.UseFlag=='0'?'上架':'未上架'}}</span>
          </template>
          </el-table-column>
          <el-table-column prop="address" label="是否可退">
            <template slot-scope="scope">
              <img src="@/images/distributor/kt.png" alt v-if="scope.row.ReturnFlag=='0'" />
              <img src="@/images/distributor/bkt.png" alt  v-if="scope.row.ReturnFlag=='1'"/>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="160"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="shopInfoFn(scope.row)">产品详情</el-button>
              <el-button type="text" @click="orderListFn(scope.row)">立即购买</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{data1.total}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="data1.total" :current-page="data1.page"   @current-change="currenchange1"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
    </el-dialog>
    <!-- 产品列表弹框结束 -->
    <!-- 产品详情开始 -->
    <proInfoDialog v-if="proInfovisible" ref="proInfoDialog" @ProHandleClose="leClose"></proInfoDialog>
    <!-- 产品详情结束 -->
    <!-- 订单列表开始 -->
    <!-- <orderListDialog v-if="ordervisible" ref="orderDialog"  :name="proName" :goodId="goodId" @closeList="closeL"></orderListDialog> -->
    <!-- 订单列表结束 -->
    <proListDialog v-if="orderListvisible" ref="orderListDialog" :name="proName" :goodId="goodId" @closeList="ListClose"></proListDialog>
    <div v-show="Visible" class="mask">
        <div class="mask_box">
          <div class="mask_title">
             微信扫码支付
             <img src="@/images/distributor/Grou.png" alt="" @click="closeFlag">
          </div>
          <div class="qrcode" ref="qrCodeUrl" id="qrcode"></div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeFlag">取 消</el-button>
            <el-button type="primary" @click="payment">确 定</el-button>
          </span>
        </div>
    </div>
  </div>
</template>

<script>
import proInfoDialog from "./dialog/proInfoDialog.vue";
import proListDialog from "../product/dialog/proListDialog.vue";
import {getDistrbutorScenicList,getProductDistributorList , DistributorRechargeSelf , rechargeDistributorRecord} from  '@/request/distributor.js'
import cityOptions from "@/assets/city.json";
import Qrcode from "qrcodejs2"
import {Message , MessageBox} from 'element-ui'
export default {
  components: {
    proInfoDialog,
    proListDialog
  },
  data() {
    return {
      RecordArr:[],
      Visible:false,
      RechargeDialogVisible:false,
      formRe:{
        token:window.sessionStorage.getItem('Token'),
        money:'',
        scenicid:'',
        pay_way:'1'
      },
      cityProvince:'',
      proName:'',
      goodId:'',
      options:[],
      shopListVisible: false, // 产品列表
      proInfovisible: false, // 产品详情
      orderListvisible: false, // 订单列表
      value: "",
      tableData: [
      ],
      data:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8,
        scenic_name:"",
        user_name:'',
        ProID:""
      },
      total:0,
      data1:{
        token:window.sessionStorage.getItem('Token'),
        scenicid:'',
        val:'',
        UseFlag:'',
        page:1,
        page_size:8,
        total:1
      },
      use:[
        {
          value:'0',
          label:'上架'
        },
        {
          value:'1',
          label:'下架'
        }
      ],
      tableData1:[],
      datas:{
        token:window.sessionStorage.getItem('Token'),
        scenicid:'',
        page:1,
        page_size:8
      },
      totals:0,
    };
  },
  created(){
    this.cityProvince = cityOptions;
    this.getList()
  },
  methods: {
    ListArr(e){
      this.datas.page = e
      this.getrange()
    },
    getrange(){
      rechargeDistributorRecord(this.datas).then(res=>{
        if(res.data.rcode=='200'){
            this.RecordArr = res.data.result.data
            this.totals = res.data.result.data.total
        }
      })
    },
    closeFlag(){
      this.formRe.scenicid = ''
      this.datas.page = 1
      this.Visible = false
      this.$nextTick(function(){
        let dom = document.getElementById("qrcode");
        while (dom.firstChild) {
          dom.removeChild(dom.firstChild);
        }
      });
    },
    payment(){
      this.formRe.scenicid = ''
      this.datas.page = 1
      this.Visible = false
      this.getList()
      this.$nextTick(function(){
        let dom = document.getElementById("qrcode");
        while (dom.firstChild) {
          dom.removeChild(dom.firstChild);
        }
      });
    },
    qrcodes(text){
      new Qrcode(this.$refs.qrCodeUrl,{
          text:text,
          width:160,
          height:160,
          colorDark:'#333',//二维码颜色
          colorLight:'#fff',//二维码背景颜色
          correctLevel:Qrcode.CorrectLevel.L//容错率,L/M/H
      })
    },
    chongzhi(){
      if(this.formRe.money==''){
        Message.error('请输入充值金额')
        return false
      }
      DistributorRechargeSelf(this.formRe).then(res=>{
        if(res.data.rcode==200){
          if(this.formRe.pay_way=='1'){
            this.RechargeDialogVisible = false
            this.Visible = true
            document.body.scrollTop = 0; // firefox
            document.documentElement.scrollTop = 0; // safari
            window.pageYOffset = 0; 
            if(this.formRe.pay_way==1){
              setTimeout(() => {
                this.qrcodes(res.data.result)
        　　　　}, 100)
            }
          }else{
            let divForm = document.getElementsByTagName('divform')
            if (divForm.length) {
              document.body.removeChild(divForm[0])
            }
            const div = document.createElement('divform')
            div.innerHTML = res.data.result // res.data就是sb支付宝返回给你的form
            document.body.appendChild(div)
            document.getElementById('alipaysubmit').target="_blank"
            document.getElementById('alipaysubmit').submit()
            MessageBox('是否支付完成?',{
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(_ => {
              this.RechargeDialogVisible = false
              this.formRe.scenicid = ''
              this.formRe.money = ''
            })
            .catch(_ => {})
          }
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    RechargeHandleClose(){
      this.RechargeDialogVisible = false
      this.formRe.scenicid = ''
      this.datas.page = 1
      this.formRe.money = ''
    },
    raRecharg(row){
      this.formRe.scenicid = row.ScenicID
      this.datas.scenicid = row.ScenicID
      this.datas.page = 1
      this.formRe.money = ''
      this.RechargeDialogVisible = true
      this.getrange()
    },
    getList2(){
      getProductDistributorList(this.data1).then(res=>{
          if(res.data.status=='ok'){
            this.tableData1 = res.data.result.data
            this.data1.total = res.data.result.total
          }
      })
    },
      // 关闭下单
    ListClose(){
      this.orderListvisible = false
    },
    cxBtns(){
      this.data1.page = 1
      this.getList2()
    },
    currenchange1(e){
      this.data1.page = e
      this.getList2()
    },
    // 查询
    Chaxun(){
      this.data.page = 1
      this.getList()
    },
    // 获取景区列表
    getList(){
      getDistrbutorScenicList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    // 点击订单列表
    orderListFn(row) {
      this.proName = row.Name
      this.goodId = row.ProductID
      this.orderListvisible = true;
      this.$nextTick(() => {
        this.$refs.orderListDialog.orderList();
      });
    },
    closeL(){
      this.ordervisible = false
    },
    // 点击产品详情
    shopInfoFn(row) {
      this.proInfovisible = true;
      this.$nextTick(() => {
        this.$refs.proInfoDialog.shopInfo(row);
      });
    },
    // 点击查看产品弹出产品列表弹框
    seeShopFn(row) {
      // this.data1.scenicid = row.ScenicID
      // this.shopListVisible = true;
      // this.getList2()
      this.$router.push({
        path:'proList',
        query:{
          id:row.ScenicID
        }
      })
    },
    // 产品列表X
    shopListHandleClose() {
      this.shopListVisible = false;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
      // 分页
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    leClose(){
      this.proInfovisible = false
    }
  }
};
</script>

<style lang='less' scoped>
  .itemBtnS {
    display: flex;
    justify-content: center;
    align-items: center;
      .el-button {
        width: 100px;
        background: #246deb;
        border-radius: 4px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        border: none;
        margin-left: -75px;
      }
    }
.shopTitle {
  margin-bottom: 20px;
  .el-input {
    width: 240px;
    margin-right: 20px;
    margin-bottom: 1rem;
  }
  .el-select {
    width: 260px;
    margin-bottom: 1rem;
    margin-right: 20px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
}
.titleStyle {
  margin-bottom: 20px;
  .el-input {
    width: 250px;
    height: 40px;
    margin-right: 20px;
    margin-bottom: 1rem;
  }
  .el-select {
    width: 260px;
    margin-bottom: 1rem;
    margin-right: 20px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.mask{
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .3);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.mask_box{
  width: 400px;
  height: 300px;
  background: #fff;
  position: relative;
}
.mask_box /deep/ .dialog-footer{
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%,0);
}
/deep/ .qrcode{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.mask_title{
  color: #333;
  font-size:16px;
  font-weight: 600;
  padding: 10px;
  text-align: center;
  position: relative;
}
.mask_title img{
  position: absolute;
  right: 10px;
  width: 15px;
  height: 15px;
  cursor: pointer;
}
</style>